import { Language } from 'common/i18n';
import * as moment from 'moment';
import * as React from 'react';

interface iProps {
    className?: string;
    lang?: Language;
    timezone?: number;
    isDST?: boolean;
    format?: string;
    style?: object;
}

interface iState {
    time: string;
}

export default class Clock extends React.Component<iProps, iState> {
    static defaultProps = {
        lang: 'zh-CN',
        timezone: 8,
        isDST: false
    };

    constructor(props: iProps) {
        super(props);
        const { lang, timezone, isDST, format } = props;

        // 初始化时间
        this.state = {
            time: this.time(lang, timezone, isDST, format)
        };
    }

    // 更新时间任务
    timer: any = setInterval(() => {
        const { lang, timezone, isDST, format } = this.props;
        this.setState({
            time: this.time(lang, timezone, isDST, format)
        });
    }, 5000);

    componentWillUnmount() {
        this.timer && clearInterval(this.timer);
    }
    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps) {
            const { lang, timezone, isDST, format } = nextProps;
            this.setState({
                time: this.time(lang, timezone, isDST, format)
            });
        }
    }
    /**
     * 同步当前时间
     * @param {string} lang
     * @param {number} timezone
     * @param {boolean} isDST
     * @param {string} format
     */
    time = (lang: string, timezone: number, isDST: boolean, format: string = 'YYYY-MM-DD dddd h:mm A') =>
        moment().locale(lang).utc()
            .utcOffset(timezone + (isDST ? 1 : 0))
            .format(format);

    render() {
        const { className, style, timezone = 0 } = this.props;
        const { time } = this.state;
        const char = timezone < 0 ? '-' : '+';
        return <div className={className} style={style}>{`(GMT${char}${Math.abs(timezone)}) ${time}`}</div>;
    }
}
